import { useEffect, useState } from 'react'
import { Routes,Route ,BrowserRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isAuth } from './store/actions/users';
import { Loader } from './utils/tools';
import MainLayout from './hoc/mainLayout';
import Header from './components/navigation/header'; 
import Home from './components/home';
import ShopsHome from './components/home/shopsHome';
import Auth from './components/auth';
import UserRegister from './components/auth/userRegister';
import  AdminProfile from './components/dashboard/profile/profile';
import NewsView from './components/news/newsView';
import ChangePsw from './components/auth/changePsw';



import Dashboard from './components/dashboard';
import AuthGuard from './hoc/authGuard';
import DashboardMain from './components/dashboard/dashboardMain';
//import ImageUpload from './components/dashboard/news/editSection/newsImageupload';
//import ImageUpload from './components/dashboard/news/editSection/imageUpload';

//SHOPS INFORMATIONS 
import AddShops from './components/dashboard/shops/editShops/addShops';
import AddShopContent from './components/dashboard/shops/editShops/addShopContent';
import ShopImageUpload from './components/dashboard/shops/editShops/shopImageUpload';
import AddShopAdress from './components/dashboard/shops/editShops/addhopAdress';
import AddShopContctInfo from './components/dashboard/shops/editShops/addShopContctInfo';
import AddShopTime from './components/dashboard/shops/editShops/addShoptime';
import AdminShops from './components/dashboard/shops/adminShops';
import ShopInfoOfcView from './components/dashboard/shops/shopInfoOfcView';
import EditShopDetails from './components/dashboard/shops/editShops/editShopdetails';
import ShopContentView from './components/dashboard/shops/shopContentView';
import EditShopContent from './components/dashboard/shops/editShops/editShopContent';
import ShopAdressView from './components/dashboard/shops/editShops/shopAdressView';
import EditShopAdress from './components/dashboard/shops/editShops/editShopAdress';
import EditShopContactView from './components/dashboard/shops/editShops/editShopCntView';
import EditShopCntInfo from './components/dashboard/shops/editShops/editShopCtnInfo';
import EditShopTimmingView from './components/dashboard/shops/editShops/editShopTimmingView';
import EdithopTimeInfo from './components/dashboard/shops/editShops/editShopTimeInfo';
import ShopInfoView from './components/shops/shopInfoView';
import ItemInfoOfcView from './components/dashboard/items/ItemInfoOfcView';

//items 
import AdminItems from './components/dashboard/items/adminItem';
import AddOnlineItem from './components/dashboard/items/editItems/addOnlineItem';
import OnlineItemImageUpload from './components/dashboard/items/editItems/itemImageUpload';
import EditOnlineItem from './components/dashboard/items/editItems/editOnlineItem';
import ItemHome from './components/home/itemHome';
import ItemInfoView from './components/items/itemInfoView';


const Router = () => {
  const [loading,setLoading] = useState(true);
  const dispatch = useDispatch();
  const users = useSelector(state=> state.users)


  useEffect(()=>{
    dispatch(isAuth())
  },[])


  useEffect(()=>{
    if(users.auth !== null){
      setLoading(false)
    }
  },[users])



  return(
    <BrowserRouter>
    { loading ?
      <Loader/>
      :
      <>
        <Header/>
        <MainLayout>
          <Routes>
          <Route path='/dashboard' element={
              <AuthGuard>
                <Dashboard/>
              </AuthGuard>
            }>  <Route index element={<DashboardMain/>}/>
                <Route path='profile' element={<AdminProfile/>}/>
                
                <Route path='shopsevnts' element={<AdminShops/>}/>
                
                
                
                <Route path ='shops/add' element={<AddShops/>}/>
                <Route path='shops/contn/:id' element={<AddShopContent/>}/>
                <Route path='shop/imageupload/:articleId' element={<ShopImageUpload/>}/>
                <Route path='shop/adrss/:id' element={<AddShopAdress/>}/>
                <Route path='shop/continfo/:id' element={<AddShopContctInfo/>}/>
                <Route path='shop/timming/:id' element={<AddShopTime/>}/>
                <Route path='shopofc/shop/:id' element={<ShopInfoOfcView/>}/>
                <Route path='shopofc/edit/:id' element={<EditShopDetails/>}/>
                <Route path='shops/editcont/:id' element={<ShopContentView/>}/>

                <Route path='shops/editcontbytrns/:id' element={<EditShopContent/>}/>
                <Route path='shop/editadrss/:id' element={<ShopAdressView/>}/>
                <Route path='shops/editadrssbytrns/:id' element={<EditShopAdress/>}/>
                <Route path='shop/editcntinfo/:id' element={<EditShopContactView/>}/>
                <Route path='shop/editcntinfobytrns/:id' element={<EditShopCntInfo/>}/>
                <Route path='shop/edittimeinfo/:id' element={<EditShopTimmingView/>}/>
                <Route path='shop/editTimebytrns/:id' element={<EdithopTimeInfo/>}/>

                
                <Route path='items' element={<AdminItems/>}/>
                <Route path ='onlineItems/add' element={<AddOnlineItem/>}/>
                <Route path='items/imageupload/:articleId' element={<OnlineItemImageUpload/>}/>
                <Route path='items/editcitem/:id' element={<EditOnlineItem/>}/>
                <Route path='items/ofcInfo/:id' element={<ItemInfoOfcView/>}/>

                
          
                

                
            </Route>

            
            
            <Route path='/auth' element={<Auth/>}/>
            <Route path='/singup' element={<UserRegister/>}/>
            <Route path='/' element={<Home/>}/>
            <Route path='/shops' element={<ShopsHome/>}/>
            <Route path='/items' element={<ItemHome/>}/>
            <Route path='/articles/article/:id' element={<NewsView/>}/>
            <Route path='/Shops/shop/:id' element={<ShopInfoView/>}/>
            <Route path='/items/item/:id' element={<ItemInfoView/>}/>
            <Route path='/changepsw' element={<ChangePsw/>}/>
            
          </Routes>
        </MainLayout>
      </>
      }
    </BrowserRouter>
  )
}

export default Router;